<template>
  <v-dialog
    v-model="SysExport.showing"
    fullscreen
    hide-overlay
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="cleed_blue">
        <v-toolbar-title>Settings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small fab dark color="white" @click="SysExport.showing = false">
          <v-icon dark color="black">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-row justify="center" alig="center">
        <v-col cols="auto">
          <v-card outlined class="ma-auto" min-width="500">
            <v-card-title> Export Types: </v-card-title>
            <v-card-text>
              <v-chip-group mandatory v-model="type" column @change="Onchange">
                <v-chip
                  filter
                  outlined
                  v-for="(type, index) in exportTypes"
                  :key="index"
                  :value="type.value"
                  :disabled="!type.enable"
                >
                  {{ type.text }}
                </v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-pagination
            v-model="page"
            :length="pages"
            :total-visible="$store.state.isMobile ? 5 : 7"
            color="rgb(17, 65, 206)"
            :disabled="pages <= 1"
            hint="Select page to export (default 5000 items per page)"
            persistent-hint
          ></v-pagination>
        </v-col>
        <v-col v-if="pages > 1" cols="12" class="text-center">
          <span>
            [Page {{ page }} of {{ pages }}] Select page to export (default 5000
            items per page)
          </span>
        </v-col>
      </v-row>

      <v-divider class="ma-6"></v-divider>

      <v-row justify="center" align="center">
        <v-col lg="6" md="6" cols="12">
          <v-card outlined>
            <v-card-text>
              <v-list-item-group
                v-if="typeElements[type]"
                v-model="settings"
                :multiple="typeElements[type].multiple"
              >
                <v-list-item
                  v-for="(element, index) in typeElements[type].values || []"
                  :key="index"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>
                        {{ element.text }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        v-for="(item, index) in element.des"
                        :key="index"
                      >
                        {{ item }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <template v-if="type == 'user'">
                  <v-subheader>Export Option</v-subheader>
                  <v-list-item>
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title> Only with email </v-list-item-title>
                        <v-list-item-subtitle>
                          Include just users with email
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn rouned color="primary" dark @click="onExport('csv')">
                <v-icon class="mr-1" size="20">mdi-file-delimited</v-icon>
                <b>CSV Export</b>
              </v-btn>
              <v-btn rouned color="primary" dark @click="onExport('json')">
                <v-icon class="mr-2" size="20">mdi-code-json</v-icon>
                <b>JSON Export</b>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "export_system",
  data() {
    return {
      page: 1,
      exportTypes: [
        { value: "user", text: "Users", enable: true },
        { value: "message", text: "Messages", enable: true },
        { value: "looks", text: "Looks", enable: false },
      ],
      typeElements: {
        user: {
          multiple: true,
          values: [
            {
              value: "username",
              text: "User name",
              des: ["include username of the users"],
            },
            {
              value: "firstname",
              text: "Firt name",
              des: ["include firstname of the users"],
            },
            {
              value: "lastname",
              text: "Last name",
              des: ["include lastname of the users"],
            },
            {
              value: "email",
              text: "Email",
              des: ["include email of the users"],
            },
            {
              value: "gender",
              text: "Gender",
              des: ["include the gender of the users"],
            },
          ],
        },
        message: {
          multiple: false,
          values: [
            {
              value: "all",
              text: "All conversations",
              des: ["export all conversation"],
            },
            {
              value: "c_email",
              text: "Email conversations",
              des: [
                "exoprt just conversations with email detect and box email.",
                "data exported with this option : (Id, Message, Firstname, Lastname, Email)",
              ],
            },
          ],
        },
      },
      type: null,
      settings: undefined,
    };
  },
  computed: {
    SysExport() {
      return this.$store.state.system_export;
    },
    pages() {
      const pages = this.$store.state.system_export.pages;
      console.log("pages :", pages);
      return pages;
    },
  },
  methods: {
    async Onchange() {
      this.settings = undefined;
      console.log(this.type);
      try {
        this.$store.dispatch("setLoader", {
          showing: true,
          text: "Please wait...",
        });
        await this.$store.dispatch("EXPORT_MESSAGES_PAGES", this.type);
        this.$store.dispatch("setLoader", { showing: false });
      } catch (error) {
        this.$store.dispatch("setLoader", { showing: false });
        console.error("Error in setSysExport:", error);
      }
    },
    onExport(format) {
      if (this.settings === undefined) {
        this.$store.dispatch("setSnackbar", {
          text: "Please select option",
          bottom: true,
          timeout: 2000,
          color: "warning",
        });
        return;
      }
      this.$store.dispatch("setLoader", {
        showing: true,
        text: "Please wait !",
      });

      if (this.type === "user") {
        this.$store
          .dispatch("EXPORT_USERS", {
            selectedElements: this.settings,
            page: this.page,
          })
          .then((res) => {
            if (format == "csv") this.toCSV(res.data);
            else this.toJSON(res.data);
            this.$store.dispatch("setLoader", { showing: false });
          })
          .catch((err) => {
            console.log(err);
            this.$store.dispatch("setSnackbar", {
              text: err.data.e || err,
              bottom: true,
              timeout: 2000,
              color: "error",
            });
            this.$store.dispatch("setLoader", { showing: false });
          });
      } else if (this.type == "message") {
        const choice = this.typeElements[this.type].values[this.settings].value;
        this.$store
          .dispatch("EXPORT_MESSAGES", { choice, page: this.page })
          .then((res) => {
            if (format == "csv") this.toCSV(res.data);
            else this.toJSON(res.data);
            this.$store.dispatch("setLoader", { showing: false });
          })
          .catch((err) => {
            console.log(err);
            this.$store.dispatch("setSnackbar", {
              text: err.data.e || err,
              bottom: true,
              timeout: 2000,
              color: "error",
            });
            this.$store.dispatch("setLoader", { showing: false });
          });
      }
    },

    downloadBlob(content, filename, contentType) {
      // Create a blob
      var blob = new Blob([content], { type: contentType });
      var url = URL.createObjectURL(blob);

      // Create a link to download it
      var pom = document.createElement("a");
      pom.href = url;
      pom.setAttribute("download", filename);
      pom.click();
    },
    toCSV(data) {
      const date = new Date();
      const options = {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };

      const export_date = date.toLocaleTimeString(
        this.$i18n.locale == "fr" ? "fr-FR" : "en-us",
        options
      );

      let columns = [];

      if (this.type == "user") {
        columns = ["User id"];
        for (let i = 0; i < this.settings.length; i++) {
          const ele = this.settings[i];
          if (ele < 5 && ele >= 0)
            columns.push(this.typeElements[this.type].values[ele].text);
        }
      } else if (this.type == "message") {
        columns = [
          "User ID",
          "GUID",
          "First Name",
          "Last Name",
          "Email",
          "Message ID",
          "Context",
          "Content",
          "Products Carousel",
          "Sender Type",
          "Conversation ID",
          "Created At",
        ];
      }

      //  CSV CREATION WITH COMMA AND QUOTE HANDLING
      let csvContent = columns.join(",") + "\n";

      data.forEach((item) => {
        if (this.type == "message") {
          //if item.content is an object and have key message, carousel inside take it only
          try {
            if (typeof item.content === "string") {
              const parsedContent = JSON.parse(item.content);
              if (parsedContent && parsedContent.message) {
                item.content = parsedContent.message;
              }
              if (parsedContent && parsedContent.carousel) {
                item.carousel = parsedContent.carousel;
              }
            }
          } catch (e) {
            console.error("Error parsing content:", e);
          }
          // EXACT DATA ORDER ACCORDING TO BACKEND
          const orderedValues = [
            item.user_id,
            item.guid,
            item.firstname,
            item.lastname,
            item.email,
            item.message_id,
            item.context,
            item.content,
            item.carousel ? JSON.stringify(item.carousel) : "",
            item.sender_type,
            item.conversation_id,
            item.sent_at,
          ];

          // Escape values that contain commas/quotes
          const escapedValues = orderedValues.map((value) => {
            if (value === null || value === undefined) return "";

            const strValue = String(value);
            // If value contains commas, quotes or line breaks
            if (
              strValue.includes(",") ||
              strValue.includes('"') ||
              strValue.includes("\n")
            ) {
              // Escape quotes by doubling them and wrap in quotes
              return `"${strValue.replace(/"/g, '""')}"`;
            }
            return strValue;
          });

          csvContent += escapedValues.join(",") + "\n";
        } else {
          // For users, keep the old logic
          csvContent += Object.values(item).join(",") + "\n";
        }
      });

      this.downloadBlob(
        csvContent,
        `${export_date}.csv`,
        "text/csv;charset=utf-8;"
      );
    },
    toJSON(data) {
      const date = new Date();
      const options = {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };

      let export_date = date.toLocaleTimeString(
        this.$i18n.locale == "fr" ? "fr-FR" : "en-us",
        options
      );
      if (!data) {
        console.error("No data");
        return;
      }

      if (!export_date) export_date = "users.json";

      let transformedData = {};

      if (this.type === "message") {
        data.forEach((item) => {
          const userId = item.user_id;

          // Create object without user_id (since it's already the key)
          const userInfo = {
            guid: item.guid,
            firstname: item.firstname,
            lastname: item.lastname,
            email: item.email,
            message_id: item.message_id,
            context: item.context,
            content: item.content,
            sender_type: item.sender_type,
            conversation_id: item.conversation_id,
            created_at: item.sent_at,
          };

          // If user_id already exists, create an array
          if (transformedData[userId]) {
            // If it's already an array, add to it
            if (Array.isArray(transformedData[userId])) {
              transformedData[userId].push(userInfo);
            } else {
              transformedData[userId] = [transformedData[userId], userInfo];
            }
          } else {
            // First message for this user
            transformedData[userId] = userInfo;
          }
        });
      } else {
        // For users, use existing adapted logic
        data.forEach((item) => {
          const userId = item.user_id || item.id;
          const userInfo = { ...item };
          delete userInfo.user_id;
          delete userInfo.id;

          transformedData[userId] = userInfo;
        });
      }

      // Convert to formatted JSON
      const jsonData = JSON.stringify(transformedData, undefined, 4);

      var blob = new Blob([jsonData], { type: "application/json" }),
        e = document.createEvent("MouseEvents"),
        a = document.createElement("a");

      a.download = `${export_date}.json`;
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["application/json", a.download, a.href].join(
        ":"
      );
      e.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
    },
  },
};
</script>
